import React from 'react';
import { List, Chip } from '@material-ui/core';
import CheckboxFacet from './CheckboxFacet/CheckboxFacet';
import styled from 'styled-components';
import "./Facets.css";
import OtherSources from '../Source/Sources';

export default function Facets(props) {

    function mapFacetName(facetName) {
        const capitalizeFirstLetter = (string) =>
            string[0] ? `${string[0].toUpperCase()}${string.substring(1)}` : '';
        facetName = facetName.trim();
        
        if (facetName.includes('metadata_storage_name')) { 
            facetName = 'source';	    	    
        }
        
        facetName = capitalizeFirstLetter(facetName);
        facetName = facetName.replace('_', ' ');
        return facetName;
    }

    function addFilter(name, value) {
        const newFilters = props.filters.concat({ field: name, value: value });
        props.setFilters(newFilters);
    }

    function removeFilter(filter) {      
        const newFilters = props.filters.filter((item) => item.value !== filter.value);
        props.setFilters(newFilters);
    }

    var facets;
    try{
        facets = Object.keys(props.facets).map(key => {
            let facetValue= props.facets[key]
            
            return <CheckboxFacet 
                key={key}
                name={key} 
                values={facetValue}
                addFilter={addFilter}
                removeFilter={removeFilter}
                mapFacetName={mapFacetName}
                setStorageName = {setStorageName}
                selectedFacets={props.filters.filter( f => f.field === key)}
              />;
          });
    } catch (error) {
        console.log(error);
    }

    function setStorageName(val){
        let storageName = ""
        switch (val) {
          case "bizagixpress_site.json":
            storageName = "BizagiXpress";
            break;
    
            case "bizagidevsdoc_site.json":
            storageName = "Bizagi Dev Docs";
            break;
    
            case "tickets_support.json":
            storageName = "Tickets Platform";
            break;
    
            case "documentation_site.json":
            storageName = "Bizagi Technical Documentation";
            break;
    
            case "internalkb_site.json":
            storageName = "Internal KB";
            break;
    
            case "cloud_operations_site.json":
            storageName = "Bizagi Operations Documentation";
            break;
    
            case "externalkb_site.json":
            storageName = "External KB";
            break;
        
          default:
            break;
        }

        return storageName;
    }

    const filters = props.filters.map((filter, index) => {
           
            return (
            <li key={index}>
                <Chip 
                    label={`${mapFacetName(filter.field)}: ${setStorageName(filter.value)}`} 
                    onDelete={() => removeFilter(filter)}
                    className="chip"
              />
            </li>);
          });


    return (
        <div id="facetPanel" className="box">
            <div className="facetbox">
                <div id="clearFilters">
                <ul className="filterlist">
                    {filters}
                </ul>
                </div>
                <FacetList component="nav" className="listitem" >
                    {facets}
                </FacetList>    
            </div>

            <div className='sources'>
                <span className="sources-title">Additional Support Sources:</span>
                <div className="margin15"></div>
                <OtherSources />
          </div>
        </div>
    );
};

const FacetList = styled(List)({
    marginTop: '32px !important'
})
